<template>
    <el-drawer :visible.sync="visible" size="80%" direction="rtl" append-to-body destroy-on-close :show-close="false" :before-close="Close">
        <div slot="title">
            <div class="w-margin-b-10">组织/部门</div>
            <div class="w-margin-b-10" style="font-size: 18px; color: #000; font-weight: bold;">{{ organize.name }}</div>
            <div style="display: flex;">
                <el-button size="mini" icon="el-icon-edit" @click="RePage()">更新信息</el-button>
                <el-button style="margin-left: 5px;" size="mini" @click="DataDelete()" type="danger">移除部门</el-button>
            </div>
        </div>
        <div class="w-padding-l-20 w-padding-r-20 w-padding-b-20">
            <el-tabs v-model="tabs">
                <el-tab-pane label="员工信息" name="employee">
                    <hrm-organize-drawer-employee :organize_id="organize.id" @onChange="DataGet()" />
                </el-tab-pane>
            </el-tabs>
        </div>
    </el-drawer>
</template>
<script>
export default {
    data() {
        return {
            visible: false,
            loading: false,
            tabs: 'employee',
            organize: {
                id: null,
            }
        }
    },
    methods: {
        Open(id) {
            this.visible = true
            this.DataGet(id)
        },
        Close(done) {
            this.$emit('onChange')
            done()
        },
        RePage() {
            this.DataGet()
        },
        DataGet(id = this.organize.id) {
            this.loading = true
            this.$http.post(
                '/9api/hrm/organize/search-first',
                {
                    search: { id: id },
                    append: []
                }
            ).then(rps => {
                this.organize = rps.data
                this.loading = false
            }) 
        },
        DataDelete() {
            this.$confirm('一旦删除将无法恢复, 是否要删除?', '警告', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                this.$http.post('/9api/hrm/organize/delete', { id: organize.id }).then((rps) => {
                    this.$emit('onChange')
                    this.visible = false
                })
            })
        },
    }
}
</script>6
